import { createFileRoute } from "@tanstack/react-router";
import { DisposalContainer } from "../../app/views/lineCheck/disposalContainer";

export const Route = createFileRoute("/disposal")({
  component: DisposalContainer,
});
